import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "tnm_track_sid";

export const getTrackSid = () => {
  let s = localStorage.getItem(SID_KEY);
  if (!s) {
    s = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SID_KEY, s);
  }
  return s;
};

// Fire-and-forget event tracker. Never throws, never blocks the UI.
export const track = (category, action, extra = {}) => {
  try {
    const payload = {
      session_id: getTrackSid(),
      user_email: extra.user_email || null,
      event_category: category,
      event_action: action,
      page_location: extra.page_location || (typeof window !== "undefined" ? window.location.pathname : ""),
    };
    axios.post(`${API}/track`, payload).catch(() => {});
  } catch {
    /* analytics must never break the app */
  }
};
